import * as ga4 from '@animaweb-js/components/ga4';

window.addEventListener('load', (event) => {
    //
    // ga4 et marketing
    //
    ga4.addGtagOnConsent(function () {
        ga4.clickGtagEvent('.btn-cta-header', 'cta_header_click', 'Header');
        ga4.clickGtagEvent('.btn-cta-header-contact', 'cta_header_contact_click', 'Header - Contact')

        ga4.clickGtagEvent('.btn-cta-footer', 'cta_footer_click', 'Footer')
        ga4.clickGtagEvent('.btn-cta-footer-phone', 'cta_footer_phone_click', 'Footer - Téléphone');

        ga4.submitGtagEvent('contact-form', 'form_contact_submit', 'Contact');
        ga4.inputStartGtagEvent('#contact-form', false, 'form_contact_input_start', 'Contact');

        ga4.submitGtagEvent('newsletter-form', 'form_newsletter_submit', 'Newsletter');
        ga4.inputStartGtagEvent('#newsletter-form', false, 'form_newsletter_input_start', 'Newsletter');

        ga4.clickGtagEvent('.btn-cta-body-phone', 'cta_body_phone_click', 'Body - Téléphone');

        ga4.elementGtagEvent('#form-contact-submited', 'page_contact_submited', 'Contact - Envoyé',
            {
                category: 'page_view',
            }
        );

        window.Brevo = window.Brevo || [];

        Brevo.push(
            [
                'init',
                {
                    client_key: '505to5j7i6igintauo9flbsd',
                }
            ]
        );
    })
});